export default __webpack_public_path__ + "static/slider2-bfd7fdad6c77e8d550f8d0d21d9d5654.jpg";